// React imports
import React from 'react';
import PropTypes from 'prop-types';
// Material UI imports
import { Typography, Button } from '@mui/material';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
// Store imports

const CustomLargeButton = ({ buttonText, handleClick, buttonStyle }) => (
  <Button
    variant="outlined"
    className="secondaryButtonStyle"
    style={buttonStyle}
    startIcon={<ArrowBackIosNewOutlinedIcon />}
    onClick={handleClick}
  >
    <Typography
      style={{
        maxWidth: '242px',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '16px',
        lineHeight: '20px',
      }}
    >
      {buttonText}
    </Typography>
  </Button>
);

CustomLargeButton.defaultProps = {
  buttonStyle: { borderColor: '#1D6460', width: '266px', height: '48px' },
};

CustomLargeButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  handleClick: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string,
};
export default CustomLargeButton;
